<template>
<span>
    <hoghugh-details></hoghugh-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import HoghughDetails from '@/components/moduls/HoghughDetails';
import PageFooter from '@/components/PageFooter';
export default {
    name :'hoghugh',
    components:{
        HoghughDetails,
        PageFooter
    }

    
};
</script>


